import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from './store'

Vue.use(VueRouter)
// route中的name需与bops中菜单管理中的code保持一致
const routes = [
  {
    path: '/',
    component: () => import('./views/SpaceList.vue'),
    name: 'Index',
    meta: {
      title: '首页',
      hideMenu: true,
    },
  },
  {
    path: '/signin',
    component: () => import('./views/Signin.vue'),
    name: 'Signin',
    meta: {
      title: '登录',
      hideMenu: true,
      hideGuide: true,
    },
  },
  {
    path: '/inviteLink/:linkCode',
    component: () => import('./views/InviteLink/index.vue'),
    name: 'InviteLink',
    meta: {
      title: '链接',
      hideMenu: true,
      hideGuide: true,
    },
  },
  {
    path: '/:spaceId/component',
    component: () => import('./views/resource/resourceComponent/ComponentList.vue'),
    name: 'ComponentList',
    meta: {
      title: '构件',
    },
  },
  {
    path: '/:spaceId/component/:componentId',
    component: () => import('./views/resource/resourceComponent/ComponentDetail.vue'),
    name: 'ComponentDetail',
    meta: {
      title: '构件详情',
      hideMenu: true,
      hideGuide: true,
    },
  },
  {
    path: '/:spaceId/module',
    component: () => import('./views/resource/resourceModule/ModuleList.vue'),
    name: 'ModuleList',
    meta: {
      title: '模块',
    },
  },
  {
    path: '/:spaceId/module/:resourceId',
    component: () => import('./views/resource/resourceModule/ModuleDetail.vue'),
    name: 'ModuleDetail',
    meta: {
      title: '模块详情',
      hideMenu: true,
      hideGuide: true,
    },
  },
  {
    path: '/:spaceId/scheme',
    component: () => import('./views/resource/resourceScheme/SchemeList.vue'),
    name: 'SchemeList',
    meta: {
      title: '模板',
    },
  },
  {
    path: '/:spaceId/scheme/:resourceId',
    component: () => import('./views/resource/resourceScheme/SchemeDetail.vue'),
    name: 'SchemeDetail',
    meta: {
      title: '模板详情',
      hideMenu: true,
      hideGuide: true,
    },
  },
  /** ---------------------- 文件 ------------------------ **/
  {
    path: '/:spaceId/file',
    component: () => import('./views/file/index.vue'),
    name: 'File',
    meta: {
      title: '文件',
    },
  },
  {
    path: '/:spaceId/file/:fileId',
    component: () => import('./views/file/3DView/ModelView.vue'),
    name: 'FileModelView',
    meta: {
      title: '轻量化查看',
      hideMenu: true,
      hideGuide: true,
    },
  },
  {
    path: '/file/share/:shareCode',
    component: () => import('./views/file/3DView/ModelShare.vue'),
    name: 'FileModelShareView',
    meta: {
      title: '轻量化分享查看',
      hideMenu: true,
      hideGuide: true,
      ignoreLogin: true,
    },
  },
  /** ------------------- 合模方案 -------------------- **/
  {
    path: '/:spaceId/file/federation/list',
    component: () => import('./views/file/planModel/FederationPlanList.vue'),
    name: 'FederationPlanList',
    meta: {
      title: '合模方案',
    },
  },
  {
    path: '/:spaceId/file/federation/preview',
    component: () => import('./views/file/3DView/FederationPlanPreview.vue'),
    name: 'FederationPlanPreview',
    meta: {
      title: '合模方案预览',
      hideGuide: true,
    },
  },
  {
    path: '/:spaceId/file/federation/view',
    component: () => import('./views/file/3DView/FederationPlanView.vue'),
    name: 'FederationPlanView',
    meta: {
      title: '合模方案查看',
      hideGuide: true,
    },
  },
  {
    path: '/file/federation/share/:shareCode',
    component: () => import('./views/file/3DView/FederationPlanShare.vue'),
    name: 'FederationPlanShareView',
    meta: {
      title: '合模方案分享查看',
      hideMenu: true,
      hideGuide: true,
      ignoreLogin: true,
    },
  },
  /** ------------------- 整合模型 --------------------- **/
  {
    path: '/:spaceId/file/integrated/list',
    component: () => import('./views/file/planModel/IntegratedModelList.vue'),
    name: 'IntegratedModelList',
    meta: {
      title: '整合模型',
    },
  },
  {
    path: '/:spaceId/file/integrated/view',
    component: () => import('./views/file/3DView/IntegratedModelView.vue'),
    name: 'IntegratedModelView',
    meta: {
      title: '整合模型查看',
      hideGuide: true,
    },
  },
  {
    path: '/file/integrated/share/:shareCode',
    component: () => import('./views/file/3DView/IntegratedModelShare.vue'),
    name: 'IntegratedModelShareView',
    meta: {
      title: '整合模型分享查看',
      hideMenu: true,
      hideGuide: true,
      ignoreLogin: true,
    },
  },
  /** -------------------- 成员 ----------------------- **/
  {
    path: '/:spaceId/member',
    component: () => import('./views/member/index.vue'),
    name: 'Member',
    meta: {
      title: '成员',
    },
  },
  /** -------------------- 设置 ---------------------- **/
  {
    path: '/:spaceId/setting',
    component: () => import('./views/setting/index.vue'),
    name: 'Setting',
    meta: {
      title: '设置',
    },
  },
  {
    path: '/downgrades',
    component: () => import('./views/downgrade/index.vue'),
    name: 'Downgrade',
    meta: {
      title: '族降级',
    },
  },
  /** --------------- 云盘内打开文件 ---------------- **/
  {
    path: '/open/spaceList',
    component: () => import('./views/openFile/OpenSpaceList.vue'),
    name: 'OpenSpaceList',
    meta: {
      title: '打开文件-空间列表',
      hideMenu: true,
    },
  },
  {
    path: '/open/:spaceId/file',
    component: () => import('./views/openFile/OpenFileList.vue'),
    name: 'OpenFileList',
    meta: {
      title: '打开文件-文件列表',
      hideMenu: true,
    },
  },
]

const router = new VueRouter({
  routes: routes,
  mode: 'hash'
  // mode: 'history',
})
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error)
}

const platform = Store.state.platform
platform === 'web' && router.beforeEach(async (to, from, next) => {
  // 针对web端
  localStorage.setItem('anchor', location.href)
  const allRoutesNames = router.options.routes.map((r) => r.name)
  if (allRoutesNames.includes(to.name)) {
    if (to.meta.ignoreLogin || to.name === 'Signin') {
      next()
      return
    }
    let user = Store.getters['user/user']
    !user.id && await Store.dispatch('user/loadUserInfo')
    user = Store.getters['user/user']
    if (user.id) {
      if (to.name === 'Signin') {
        // 跳转到首页
        next({ name: 'Index' })
      } else {
        next()
      }
    } else {
      if (to.name !== 'Signin') {
        // 跳转到登录页面
        const href = encodeURIComponent(window.location.href)
        const query = {
          to: to.name,
          dest: to.name === 'Index' ? '' : href
        }

        next({ name: 'Signin', query })
      }
    }
  }
})

export default router
